/*
 * @Author: Teemo Ding
 * @Date: 2021-03-05 14:45:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-08 11:17:11
 * @FilePath: /unifyxp-v2-store-portal的副本/src/pages/ProductsList/store/index.tsx
 */
import { createSlice } from '@reduxjs/toolkit';
import { unique } from '@/src/tools/helper';
//import { tabsConfig } from '../ProductsListConfig';

const defaultState = {
  tabsActive: '',
  searchList: [],
  searchText: 0,
  filter: {},
  sort: {
    name: 'Created ( newest )',
    key: 8,
    data: { field: 'createdDate', ascent: false },
  },
  tableSettings: [],
};
//TODO:Filter单选和多选的问题
const productListSlice = createSlice({
  name: 'productList',
  initialState: defaultState,
  reducers: {
    searchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    onFilter: (state, action) => {
      state.filter = action.payload;
    },
    eachOnFilter: (state, action) => {
      state.filter[action.payload.key] = action.payload.data;
    },
    filterClose: (state, action) => {
      state.filter[action.payload.key].splice(action.payload.index, 1);
    },
    sortBy: (state, action) => {
      state.sort = action.payload;
    },
    activeChange: (state, action) => {
      state.tabsActive = action.payload;
    },
    setTableSetting: (state, action) => {
      state.tableSettings = action.payload;
    },
    removeFilter: (state) => {
      state.searchList = [];
      state.filter = {};
    },
  },
});

export const {
  searchList,
  deleteSearch,
  onFilter,
  eachOnFilter,
  sortBy,
  activeChange,
  filterClose,
  removeFilter,
  setTableSetting,
} = productListSlice.actions;

export default productListSlice.reducer;
